(function ($) {

  /* initVideo( args )
   *   Converts a div with a `data-video-id` attribute into an JavaScript iframe embed
   *   Fades placeholder image out when video begins to play
   *   Enables a toggleable play/pause button
   */
  const initVideo = (target) => {
    if (!$(target).hasClass('initializing')) {
      $(target).addClass('initializing');
      const $wrapper = $(target).closest('.page-section');
      //console.log('initVideo for ' + target);

      const videoId = $(target).data('video-id');
      $(target).parent().addClass('youtube-container');

      if (!videoId) {
        console.error(`No video id was defined. Expected ${target} to have a 'data-video-id' attribute.`);
      }

      const player = new YT.Player(target, {
        height: '800',
        width: '1440',
        videoId: videoId,
        playerVars: {
          playsinline: 1,
          controls: 0,
          disablekb: 1,
          showinfo: 0,
          wmode: 'transparent',
          modestbranding: 1,
          rel: 0,
          loop: 1,
          playlist: videoId,
          fs: 0,
          cc_load_policy: 0,
          iv_load_policy: 3,
          autohide: 0,
          origin: window.location
        },
        events: {
          'onReady': () => {
            player.mute();
            player.playVideo();

            $wrapper.find('.autoplay-video__container').addClass('initialized');
          },
          'onStateChange': (event) => {
            const $button = $wrapper.find('.autoplay-video__button.play_pause');
            if (player.getPlayerState() == window.YT.PlayerState.PLAYING) {
              $wrapper.find('.autoplay-video__button').show();
              $wrapper.find('.autoplay-video__overlay').addClass('video-hidden');
              $button
                .removeClass('play')
                .addClass('pause')
                .find('.label')
                .text('Pause');
            } else {
              $button
                .removeClass('pause')
                .addClass('play')
                .find('.label')
                .text('Play');
            }

            $(document).on('click', '.autoplay-video__button.play_pause', () => {
              const $vid = $wrapper.find('.autoplay-video__container');
              if ($vid.hasClass('initialized')) {
                if (player.getPlayerState() !== window.YT.PlayerState.PLAYING) {
                  player.playVideo();
                } else {
                  player.pauseVideo();
                }
              }
            });
        
            $(document).on('click', '.autoplay-video__button.mute_unmute', () => {
              const $vid = $wrapper.find('.autoplay-video__container');
              if ($vid.hasClass('initialized')) {
                if (player.isMuted()) {
                  player.unMute();
                  $(e.target).removeClass('unmute').addClass('mute');
                } else {
                  player.mute();
                  $(e.target).removeClass('mute').addClass('unmute');
                }
              }
            });
          }
        }
      });
    }
  }

  const elementInViewport = (el) => {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;
  
    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
  
    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  };

  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = () => {
    $('.autoplay-video__container.youtube').each((i, el) => {
      if (elementInViewport(el)) {
        initVideo(el);
      }
    });

    window.addEventListener('scroll', () => {
      $('.autoplay-video__container.youtube').each((i, el) => {
        if (elementInViewport(el)) {
          initVideo(el);
        }
      });
    });
  };

})(jQuery);